export default __webpack_public_path__ + "static/media/Marketron-logo.37cf1b28.svg";